import React from 'react';

import { PublicPage } from 'api/website';
import Container from 'components/Container';

import { ContentPageSidebar } from './ContentPageSidebar';
import { ContentPageSidebarBlockComponent } from './ContentPageSidebarBlockComponent';

type Props = {
  content: PublicPage;
};

export function ContentPageUpperSidebar({ content }: Props) {
  return (
    <ContentPageSidebar>
      {content.sidebar.contentBlocksTop.map((block, index) => (
        <Container key={block.id}>
          <ContentPageSidebarBlockComponent
            content={content}
            block={block}
            index={index}
          />
        </Container>
      ))}
    </ContentPageSidebar>
  );
}
